import React from 'react';
import { Modal, Button } from 'antd';
import { CloseOutlined, CheckCircleFilled } from '@ant-design/icons';
import styles from './RestoreSuccessModal.module.scss';

type Props = {
  visible: boolean;
  turbinePath: string;
  onClose: () => void;
};

export const RestoreSuccessModal: React.FC<Props> = ({ visible, turbinePath, onClose }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={560}
      bodyStyle={{ padding: 0 }}
      destroyOnClose
    >
      <div className={styles.container}>
        <div className={styles.headerSection}>
          <h2 className={styles.title}>Restore Request Submitted</h2>
          <CloseOutlined className={styles.closeIcon} onClick={onClose} />
        </div>

        <div className={styles.body}>
          <div className={styles.successBanner}>
            <CheckCircleFilled className={styles.successIcon} />
            <span className={styles.successText}>Your restore request has been successfully submitted.</span>
          </div>

          <div className={styles.infoSection}>
            <span className={styles.infoLabel}>Turbine</span>
            <div className={styles.turbinePathValue}>{turbinePath}</div>
          </div>

          <p className={styles.messageText}>
            The data for this turbine is being retrieved from deep archive. This process may take up to 48 hours. You
            will receive an email notification once the data becomes available.
          </p>
        </div>

        <div className={styles.footerSection}>
          <Button type='primary' onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};
